import React, { useState } from "react";
import Popup from "reactjs-popup";

export default function SelectPopup(props) {
  const { content, trigger, position } = props;

  return (
    <Popup position={position} on="click" trigger={(open) => trigger}>
      <div>
        {content}
      </div>
    </Popup>
  );
}
